// extracted by mini-css-extract-plugin
module.exports = {"container":"_mainTitle_container__6eU8E","siteLink":"_mainTitle_siteLink__i_SvU"};